export function mergeFrenchImage<
  T extends { id: string; alternate_languages: { id: string; lang: string }[]; data: any },
>(localDocs: T[], frDocs: (T | null)[], currentLocale: string, frLocale: string): T[] {
  return localDocs.map((doc) => {
    if (currentLocale === frLocale) {
      return {
        ...doc,
        data: {
          ...doc.data,
          ["featuredImage"]: doc.data?.["featuredImage"] || null,
        },
      };
    }

    const frId = doc.alternate_languages.find((alt) => alt.lang === frLocale)?.id;
    const fr = frDocs.find((f) => f?.id === frId);

    return {
      ...doc,
      data: {
        ...doc.data,
        ["featuredImage"]: fr?.data?.["featuredImage"] || null,
      },
    };
  });
}
